module.exports = __webpack_public_path__ + "static/media/logo1.6d9d242c.png";